// extracted by mini-css-extract-plugin
module.exports = {"frame":"FramedImage-module--frame--3eMQx","hover":"FramedImage-module--hover--bI74I"};